import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const LevelThree = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.LEVEL_3} />
}

export default LevelThree;